import "./styles.css";
import React from "react";
import { Modal, Radio, Tree, Divider, Input, Form, Table } from "antd";
import global from '../../../common/utility/global';


class ConfiguracionModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleCancel = () => {
    this.props.onClose();
    this.props.form.resetFields();
  };

  handleOk = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {

      console.log(values);
      if (!err) {
        const form = {
          id: values.id,
          /*           flagPermisoMV: values.flagPermisoMV,
                    flagPermisoMC: values.flagPermisoMC,
                    flagPermisoML: values.flagPermisoML,
                    flagPermisoOC: values.flagPermisoOC,
                    flagPermisoOS: values.flagPermisoOS,
                    flagPermisoOP: values.flagPermisoOP,
                    flagPermisoCC: values.flagPermisoCC,
          
                    flagPermisoComprobanteContingencia: values.flagPermisoComprobanteContingencia,
                    flagPermisoCaja: values.flagPermisoCaja */

        };
        this.props.onSave(form, this.props.form);
      }
    });
  };



  render() {

    const rowSelection = {
      getCheckboxProps: (record) => {
        const rowIndex = this.props.formValues.detalleCobranza.findIndex((item) => item.rowIndex == record.rowIndex);
        console.log(rowIndex)
        if (rowIndex > 0) {
          return {
            disabled: false
          };
        } else {
          return {
            disabled: true
          };
        }

      }
    };

    const { getFieldDecorator } = this.props.form;
    getFieldDecorator("id", {
      initialValue: this.props.formValues.id,
    });
    return (
      <Modal
        title={"Configuración de Usuario - " + this.props.formValues.usuario}
        visible={this.props.visibleConfiguracion}
        cancelText={"Cancelar"}
        okText={"Guardar"}
        onCancel={this.handleCancel}
        onOk={this.handleOk}
        style={{ top: 30,padding:30 }}
        width="1220px"
      >
        <Form autoComplete="nope">




            <div className="row">
              <div className="col-md-9 form-group">
                <Form.Item label="¿El usuario puede generar comprobantes de contigencia? ">
                </Form.Item>
              </div>

              <div className="col-md-3 form-group">
                <Form.Item>
                  <Radio.Group
                    value={this.props.formValues.flagPermisoComprobanteContingencia ? 1 : 0}
                    onChange={(e) => this.props.onChange("flagPermisoComprobanteContingencia", e.target.value)}
                  >
                    <Radio value={1}>SI</Radio>
                    <Radio value={0}>NO</Radio>
                  </Radio.Group>

                </Form.Item>
              </div>
            </div>

            <div className="row">
              <div className="col-md-9 form-group">
                <Form.Item label="¿El usuario puede modificar fecha de comprobantes? ">
                </Form.Item>
              </div>

              <div className="col-md-3 form-group">
                <Form.Item>
                  <Radio.Group
                    value={this.props.formValues.flagPermisoFC ? 1 : 0}
                    onChange={(e) => this.props.onChange("flagPermisoFC", e.target.value)}
                  >
                    <Radio value={1}>SI</Radio>
                    <Radio value={0}>NO</Radio>
                  </Radio.Group>

                </Form.Item>
              </div>
            </div>


            <div className="row">
              <div className="col-md-9 form-group">
                <Form.Item label="¿El usuario puede verificar todas las series del módulo de ventas?">
                </Form.Item>
              </div>

              <div className="col-md-3 form-group">
                <Form.Item>
                  <Radio.Group
                    value={this.props.formValues.flagPermisoMV ? 1 : 0}
                    onChange={(e) => this.props.onChange("flagPermisoMV", e.target.value)}
                  >
                    <Radio value={1}>SI</Radio>
                    <Radio value={0}>NO</Radio>
                  </Radio.Group>

                </Form.Item>
              </div>
            </div>



            <div className="row">
              <div className="col-md-9 form-group">
                <Form.Item label="¿El usuario puede verificar todas las series del módulo de logística?">
                </Form.Item>
              </div>

              <div className="col-md-3 form-group">
                <Form.Item>
                  <Radio.Group
                    value={this.props.formValues.flagPermisoMC ? 1 : 0}
                    onChange={(e) => this.props.onChange("flagPermisoMC", e.target.value)}
                  >
                    <Radio value={1}>SI</Radio>
                    <Radio value={0}>NO</Radio>
                  </Radio.Group>

                </Form.Item>
              </div>
            </div>



            <div className="row">
              <div className="col-md-9 form-group">
                <Form.Item label="¿El usuario puede aprobar o rechazar el Requerimiento(Logística)? ">
                </Form.Item>
              </div>

              <div className="col-md-3 form-group">
                <Form.Item>
                  <Radio.Group
                    value={this.props.formValues.flagPermisoML ? 1 : 0}
                    onChange={(e) => this.props.onChange("flagPermisoML", e.target.value)}
                  >
                    <Radio value={1}>SI</Radio>
                    <Radio value={0}>NO</Radio>
                  </Radio.Group>

                </Form.Item>
              </div>
            </div>

            <div className="row">
              <div className="col-md-9 form-group">
                <Form.Item label="¿El usuario puede aprobar o rechazar la orden de compra?">
                </Form.Item>
              </div>

              <div className="col-md-3 form-group">
                <Form.Item>
                  <Radio.Group
                    value={this.props.formValues.flagPermisoOC ? 1 : 0}
                    onChange={(e) => this.props.onChange("flagPermisoOC", e.target.value)}
                  >
                    <Radio value={1}>SI</Radio>
                    <Radio value={0}>NO</Radio>
                  </Radio.Group>

                </Form.Item>
              </div>
            </div>


            <div className="row">
              <div className="col-md-9 form-group">
                <Form.Item label="¿El usuario puede aprobar o rechazar la orden de servicio?">
                </Form.Item>
              </div>

              <div className="col-md-3 form-group">
                <Form.Item>
                  <Radio.Group
                    value={this.props.formValues.flagPermisoOS ? 1 : 0}
                    onChange={(e) => this.props.onChange("flagPermisoOS", e.target.value)}
                  >
                    <Radio value={1}>SI</Radio>
                    <Radio value={0}>NO</Radio>
                  </Radio.Group>

                </Form.Item>
              </div>
            </div>


            <div className="row">
              <div className="col-md-9 form-group">
                <Form.Item label="¿El usuario puede aprobar o rechazar la orden de producción? ">
                </Form.Item>
              </div>

              <div className="col-md-3 form-group">
                <Form.Item>
                  <Radio.Group
                    value={this.props.formValues.flagPermisoOP ? 1 : 0}
                    onChange={(e) => this.props.onChange("flagPermisoOP", e.target.value)}
                  >
                    <Radio value={1}>SI</Radio>
                    <Radio value={0}>NO</Radio>
                  </Radio.Group>

                </Form.Item>
              </div>
            </div>



            <div className="row">
              <div className="col-md-9 form-group">
                <Form.Item label="¿El usuario puede aprobar o anular el comprobante de compra?  ">
                </Form.Item>
              </div>

              <div className="col-md-3 form-group">
                <Form.Item>
                  <Radio.Group
                    value={this.props.formValues.flagPermisoCC ? 1 : 0}
                    onChange={(e) => this.props.onChange("flagPermisoCC", e.target.value)}
                  >
                    <Radio value={1}>SI</Radio>
                    <Radio value={0}>NO</Radio>
                  </Radio.Group>

                </Form.Item>
              </div>
            </div>



            <div className="row">
              <div className="col-md-9 form-group">
                <Form.Item label="¿El usuario es responsable de la caja de cobranza? ">
                </Form.Item>
              </div>

              <div className="col-md-3 form-group">
                <Form.Item>
                  <Radio.Group
                    value={this.props.formValues.flagPermisoCaja ? 1 : 0}
                    onChange={(e) => this.props.onChange("flagPermisoCaja", e.target.value)}
                  >
                    <Radio value={1}>SI</Radio>
                    <Radio value={0}>NO</Radio>
                  </Radio.Group>

                </Form.Item>
              </div>
            </div>


            <div className="row">
              <div className="col-md-9 form-group">
                <Form.Item label="¿El usuario puede revisar todas las cajas de cobranza?">
                </Form.Item>
              </div>

              <div className="col-md-3 form-group">
                <Form.Item>
                  <Radio.Group
                    value={this.props.formValues.flagPermisoTS ? 1 : 0}
                    onChange={(e) => this.props.onChange("flagPermisoTS", e.target.value)}
                  >
                    <Radio value={1}>SI</Radio>
                    <Radio value={0}>NO</Radio>
                  </Radio.Group>

                </Form.Item>
              </div>
            </div>

            <div className="col-md-12 form-group">
              <Divider orientation="center">Control de Crédito</Divider>
            </div>

            <div className="row">
              <div className="col-md-9 form-group">
                <Form.Item label="¿El usuario puede generar el comprobante de venta?">
                </Form.Item>
              </div>

              <div className="col-md-3 form-group">
                <Form.Item>
                  <Radio.Group
                    value={this.props.formValues.flagPermisoGCG ? 1 : 0}
                    onChange={(e) => this.props.onChange("flagPermisoGCG", e.target.value)}
                  >
                    <Radio value={1}>SI</Radio>
                    <Radio value={0}>NO</Radio>
                  </Radio.Group>

                </Form.Item>
              </div>
            </div>

            <div className="row">
              <div className="col-md-9 form-group">
                <Form.Item label="¿El usuario puede visualizar todos los créditos de los asesores?">
                </Form.Item>
              </div>

              <div className="col-md-3 form-group">
                <Form.Item>
                  <Radio.Group
                    value={this.props.formValues.flagPermisoUTC ? 1 : 0}
                    onChange={(e) => this.props.onChange("flagPermisoUTC", e.target.value)}
                  >
                    <Radio value={1}>SI</Radio>
                    <Radio value={0}>NO</Radio>
                  </Radio.Group>

                </Form.Item>
              </div>
            </div>


            <div className="col-md-12 form-group">
              <Divider orientation="center"></Divider>
            </div>

            <div className="row">
              <div className="col-md-6 form-group">
                <label>Configuración de Ventas</label>

                <Table
                  className={'logistica-table-kardex-almacen'}
                  scroll={{ x: true }}
                  size="small"
                  style={{ overflowX: 'auto' }}
                  dataSource={this.props.searchPermiso.dataSource}

                  rowKey={record => record.idEstablecimiento}
                  onExpand={async (expanded, record) => {
                    // await this.props.handleNivel0(0, expanded, record);
                  }}
                  expandedRowRender={(record) => {
                    return (
                      <div style={{ margin: '10px 0px' }}>
                        {

                          <Table
                            className={'logistica-table-kardex-almacen'}
                            scroll={{ x: true }}
                            size="small"
                            style={{ overflowX: 'auto' }}
                            dataSource={record.lstAlmacen}
                            rowSelection={{
                              onChange: this.props.onChangeColumn,
                              selectedRowKeys: this.props.searchPermiso.selectedColumnKeys,
                              hideDefaultSelections: false,

                            }}
                            rowKey={record => record.rowIndex}
                            columns={[
                              {
                                title: 'Almacén',
                                dataIndex: 'almacen',
                                key: 'almacen',
                                align: "center",
                              }

                            ]}
                          />

                        }
                      </div>
                    )
                  }}

                  columns={[
                    {
                      title: 'Establecimiento/Almacén',
                      dataIndex: 'establecimiento',
                      key: 'establecimiento',
                      align: "center",

                      render: (value) => {
                        return (<div className="custom-options" >
                          <span> {value == null ? "" : value.split("-")[0]}</span>
                        </div>)
                      }
                    }

                  ]}
                />

              </div>

              <div className="col-md-6 form-group" hidden={!this.props.formValues.flagPermisoCaja}>
                <label>Configuración pago de caja Cobranza</label>
                <Table
                  className={'logistica-table-kardex-almacen'}
                  scroll={{ x: true }}
                  size="small"
                  style={{ overflowX: 'auto' }}

                  dataSource={this.props.searchPermiso.dataSource}
                  rowKey={record => record.rowIndex}
                  onExpand={async (expanded, record) => {
                    // await this.props.handleNivel0(0, expanded, record);
                  }}
                  expandedRowRender={(record) => {
                    return (
                      <div style={{ margin: '10px 0px' }}>
                        {

                          <Table
                            className={'logistica-table-kardex-almacen'}
                            scroll={{ x: true }}
                            size="small"
                            style={{ overflowX: 'auto' }}
                            dataSource={record.lstSerie}
                            rowSelection={{
                              onChange: this.props.onChangeRow,
                              selectedRowKeys: this.props.searchPermiso.selectedRowKeys,
                              hideDefaultSelections: false,
                              //...rowSelection
                            }}
                            rowKey={record => record.rowIndex}
                            columns={[
                              {
                                title: 'Serie',
                                dataIndex: 'serie',
                                key: 'serie',
                                align: "center"
                              }

                            ]}
                          />

                        }
                      </div>
                    )
                  }}
                  columns={[
                    {
                      title: 'Establecimiento/Serie',
                      dataIndex: 'establecimiento',
                      key: 'establecimiento',
                      align: "center",

                      render: (value) => {
                        return (<div className="custom-options" >
                          <span> {value == null ? "" : value.split("-")[0]}</span>
                        </div>)
                      }
                    }
                  ]}
                />
              </div>
            </div>

        </Form>
      </Modal>
    );
  }
}
export default Form.create()(ConfiguracionModal);
